import { Link } from "react-router-dom";
import { Truck, RefreshCw, Shield, ScrollText, HeartHandshake, HelpCircle, Mail } from "lucide-react";
import { useMeta } from "@/lib/site";
import { Overline, Reveal } from "@/components/Reveal";

const items = [
  { to: "/customer-care/shipping-delivery", title: "Shipping & Delivery", desc: "Timelines, coverage and how your parcel travels across Pakistan.", Icon: Truck },
  { to: "/customer-care/returns-exchanges", title: "Returns & Exchanges", desc: "Our policy on returns, exchanges and damaged parcels.", Icon: RefreshCw },
  { to: "/customer-care/privacy", title: "Privacy Policy", desc: "What we collect, why, and how we protect it.", Icon: Shield },
  { to: "/customer-care/terms", title: "Terms & Conditions", desc: "The terms that govern every order and visit.", Icon: ScrollText },
  { to: "/customer-care/complaints", title: "Customer Care & Complaints", desc: "How we listen, and how we make things right.", Icon: HeartHandshake },
  { to: "/customer-care/faq", title: "FAQ", desc: "Answers to the questions we hear most often.", Icon: HelpCircle },
  { to: "/customer-care/contact", title: "Contact Us", desc: "WhatsApp, email and Instagram — we reply within hours.", Icon: Mail },
];

export default function CustomerCare() {
  useMeta("Customer Care", "Bonheur Eternal customer care — shipping, returns, privacy, terms, complaints, FAQ and contact.");
  return (
    <div className="pt-32 md:pt-44 pb-32 px-5 md:px-8 max-w-6xl mx-auto">
      <Reveal className="max-w-2xl">
        <Overline>Customer Care</Overline>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2B2118] mt-4 tracking-tight">Cared for, from<br />first spray to last.</h1>
        <p className="mt-6 text-[#5A4C3C] leading-loose">
          Everything you may want to know before or after your order. If anything remains unanswered, we are one message away.
        </p>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-20">
        {items.map((it, i) => (
          <Reveal key={it.to} delay={(i % 3) * 0.08}>
            <Link
              to={it.to}
              data-testid={`care-card-${it.to.split("/").pop()}`}
              className="group block border border-[#2B2118]/[0.07] p-8 h-full hover:border-[#8F6B3A]/40 transition-colors duration-500 bg-[#DDD3C1]/60"
            >
              <it.Icon size={20} strokeWidth={1.25} className="text-[#8F6B3A]" />
              <h2 className="font-display text-xl text-[#2B2118] mt-5 group-hover:text-[#8F6B3A] transition-colors">{it.title}</h2>
              <p className="mt-3 text-sm text-[#6E6151] leading-relaxed">{it.desc}</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
